import { observer } from "mobx-react-lite";
import * as React from "react";

import { MFormStore } from "./MFormStore";
import { MfNode, RenderCtx } from "./node/MfNode";

type PropsMForm = {
  store: MFormStore;
  onChange?: () => void;
};

export const MForm: React.FC<PropsMForm> = observer(({ store, onChange }) => {
  const { root, errors, externalErrorsByPath } = store;
  const { Render: RootRender } = root;
  const ctx: RenderCtx = {
    root,
    errors,
    externalErrorsMap: externalErrorsByPath,
    onChange: (src?: MfNode) => {
      if (src) {
        store.onValueChange(src);
      }
      store.onChange();
      onChange?.();
    },
    touch: (dataPath) => store.touch(dataPath),
    isTouched: (dataPath) => store.isTouched(dataPath),
  };
  return <RootRender ctx={ctx} />;
});
